import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ChangeDetectionStrategy
} from '@angular/core';
import { StaffInfoAudit } from '../../+models/person-profile-audit.model';

@Component({
  selector: 'sd-portal-person-profile-staff-detail-audit-list',
  templateUrl: './person-profile-staff-detail-audit-list.component.html',
  styleUrls: ['./person-profile-staff-detail-audit-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PersonProfileStaffDetailAuditListComponent implements OnInit {
  @Input() staffInfoId: number;
  @Input() loading: boolean;
  @Input() staffInfoAudits: StaffInfoAudit[];

  @Output() loadStaffInfoAudits: EventEmitter<number> = new EventEmitter<number>();
  @Output() nextPage: EventEmitter<number> = new EventEmitter<number>();

  constructor() {}

  ngOnInit() {}

  loadData() {
    this.loadStaffInfoAudits.emit(this.staffInfoId);
  }

  onNextPage() {
    this.nextPage.emit(this.staffInfoId);
  }
}
